import { useState } from 'react'
import { Space, Switch } from 'antd'
import PayItemSelect from 'components/CIMSSelect/common/PayItemSelect'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSDateRange from 'components/CIMSDateRange'

const AdvancedOptions: React.FC = () => {
  const [checked, setChecked] = useState(false)
  return (
    <>
      <Space size="small" style={{ marginBottom: '24px' }} align="center">
        Advanced Options
        <Switch
          onChange={() => setChecked((prev) => !prev)}
          checked={checked}
        />
      </Space>
      {checked && (
        <>
          <CIMSFormItem
            name="payItemIds"
            label="Pay Item(s)"
            help="Does not filter Pay Items by default. When enabled, filters records where the Pay Item would appear on the report."
          >
            <PayItemSelect simple mode="multiple" />
          </CIMSFormItem>
          <CIMSFormItem
            name="dateRange"
            label="Date Range"
            help="Selected dates are included in the export. Runs for all dates by default. Which date to filter against is specific for each report."
          >
            <CIMSDateRange />
          </CIMSFormItem>
        </>
      )}
    </>
  )
}

export default AdvancedOptions
